import * as angular from 'angular';
import { SignInOption } from '~/modules/sign-in/types/sign-in-option.type';
import { getCsrfToken } from '@mode/shared/util-js';
import { FeatureFlag, FeatureFlagsFacade } from '@mode/shared/contract-common';
import { first } from 'rxjs/operators';
import { formSubmit } from '@mode/legacy/data-access-model-js';

export const SignInSsoButtonComponent: angular.IComponentOptions = {
  controller: class {
    static $inject = ['$window', '$location', 'FeatureFlagsFacade'];
    private option: SignInOption;
    private authToken: string;
    private loggedOutSignInFlowEnabled: boolean;
    private aadScimEnabled: boolean;
    private autoRedirectToSso: boolean;
    private redirectUrl: string;

    constructor(
      private $window: Window,
      private $location,
      private featureFlagsFacade: FeatureFlagsFacade
    ) {
      this.authToken = this.getAuthToken();
      this.featureFlagsFacade
        .asObservable(FeatureFlag.LoggedOutSignInFlow)
        .pipe(first())
        .subscribe((enabled) => {
          this.loggedOutSignInFlowEnabled = enabled;
        });
      this.featureFlagsFacade
        .asObservable(FeatureFlag.AzureActiveDirectoryScim)
        .pipe(first())
        .subscribe((enabled) => {
          this.aadScimEnabled = enabled;
        });
      this.featureFlagsFacade
        .asObservable(FeatureFlag.AutoRedirectToProvidedSSO)
        .pipe(first())
        .subscribe((enabled) => {
          this.autoRedirectToSso = enabled;
        });
    }

    $onInit() {
      if (this.autoRedirectToSso) {
        const params = this.$location.search();
        if (params.redirect_to_sso === this.option.url) {
          formSubmit(this.option.url, {
            fields: {
              authenticity_token: this.authToken,
              ...(params.redirect_uri && { redirect_uri: params.redirect_uri }),
              ...(params.login_hint && { login_hint: params.login_hint }),
            },
          });
        }
      }
    }

    getNameLabel() {
      if (this.aadScimEnabled) {
        if (this.option.preferredName) {
          return this.option.preferredName;
        }

        // special treatment for microsoft o365
        if (this.option.name === 'O365') {
          return 'Microsoft';
        }
      } else {
        if (this.option.preferredName) {
          return `Sign in with ${this.option.preferredName}`;
        }

        // special treatment for microsoft o365
        if (this.option.name === 'O365') {
          return 'Microsoft Office 365';
        }
      }
      return this.option.name;
    }

    getAuthToken() {
      return getCsrfToken(this.$window.document);
    }

    handleClick($event) {
      $event.preventDefault();

      formSubmit(this.option.url, {
        fields: {
          authenticity_token: this.authToken,
          ...(this.loggedOutSignInFlowEnabled && this.redirectUrl && { redirect_to: this.redirectUrl }),
        },
      });
    }
  },
  controllerAs: 'ctrl',
  bindings: {
    option: '<',
    redirectUrl: '<',
  },
  template: `
    <button class="btn-lg sso-button sign-in-btn" ng-click="ctrl.handleClick($event)">
      <i class="align-md-icon md-icon"
        ng-class="{'icon-signup-google': !ctrl.option.saml && ctrl.option.name === 'Google',
          'icon-signup-slack': !ctrl.option.saml && ctrl.option.name === 'Slack',
          'icon-signup-o365': !ctrl.option.saml && ctrl.option.name === 'O365',
          'icon-signup-lock': ctrl.option.saml && ctrl.option.vendor !== 'Okta',
          'icon-signup-okta': ctrl.option.saml && ctrl.option.vendor === 'Okta' }"
        />
      </i>
      <span class="sso-name">
        {{ ctrl.getNameLabel() }}
      </span>
    </button>
  `,
};
